import React from 'react';
import { featured } from '../mock';
import { SectionHead } from './Destinations';

export default function Featured() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHead
          eyebrow="FEATURED DESTINATIONS"
          title="Discover Our Most Loved Destinations."
          sub="Explore destinations that continue to inspire travellers year after year\u2014from iconic cultural landmarks to breathtaking natural landscapes."
        />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {featured.map((f, i) => (
            <a
              key={f.name}
              href="#packages"
              className="group relative rounded-2xl overflow-hidden aspect-[3/4] reveal shadow-[0_10px_26px_rgba(11,37,69,0.1)]"
              style={{ transitionDelay: `${(i % 6) * 50}ms` }}
            >
              <img src={f.img} alt={f.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B2545]/80 to-transparent" />
              <h3 className="absolute bottom-4 left-0 right-0 text-center font-heading text-white text-lg font-bold">{f.name}</h3>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
